import React from 'react';
import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Heading,
  Spinner,
  Text,
  VStack,
} from '@chakra-ui/react';

interface LoginProps {
  setIsLoading: (loading: boolean) => void;
}

const Login: React.FC<LoginProps> = () => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      bg="gray.50"
    >
      <Card maxW="md" mx="auto">
        <CardHeader>
          <Heading size="lg" textAlign="center">
            Waitlist Management
          </Heading>
        </CardHeader>
        <CardBody>
          <VStack spacing={4}>
            <Spinner size="lg" color="blue.500" />
            <Text textAlign="center" color="gray.600">
              Authenticating...
            </Text>
          </VStack>
        </CardBody>
      </Card>
    </Box>
  );
};

export default Login; 